export default __webpack_public_path__ + "static/media/P948_CoC.7c1bb440.pdf";